export default __webpack_public_path__ + "static/media/bakery.8b8106e8.svg";